export type TagTone = "accent" | "secondary" | "primary";

export interface TickerItem {
  id: number;
  time: string;
  text: string;
  mark: string;
}

export const breakingTicker: TickerItem[] = [
  { id: 1, time: "14:32", mark: "急", text: "头部团购平台被曝低价券结算抽成内幕，商家佣金明涨暗降再遭起底" },
  { id: 2, time: "13:48", mark: "更", text: "某新锐茶饮跑路始末新增关键证据：供应商欠款清单首度完整流出" },
  { id: 3, time: "12:05", mark: "新", text: "直播带货话术脚本合集再补 6 份，剧本式逼单链路逐句拆解" },
  { id: 4, time: "11:20", mark: "爆", text: "求职 App 付费内推争议发酵，中介话术与真实资源匹配度复盘" },
  { id: 5, time: "10:41", mark: "更", text: "明星联名白牌价格跳水始末，从首发溢价到清仓价的完整时间线更新" },
  { id: 6, time: "09:56", mark: "急", text: "培训机构 '保过' 承诺纠纷集中出现，学员群诉材料进入梳理阶段" },
  { id: 7, time: "09:12", mark: "新", text: "加盟招商会录音档新增三期，快招话术模板逐条标注风险点" },
];

export interface LeadNews {
  tag: string;
  tagTone: TagTone;
  title: string;
  lede: string;
  count: string;
  author: string;
  img: string;
}

export const heroLead: LeadNews = {
  tag: "头条深挖",
  tagTone: "accent",
  title: "网红餐饮加盟内幕：从全网爆红到门店塌房，一张完整时间线",
  lede: "同一套「排队剧本」如何被包装成流量神话？我们从立项、招商到加盟商集体维权，把一桩爆红连锁的来龙去脉按证据顺序排开，讲透钱从哪里来、坑挖在哪里。",
  count: "万字长文 · 时间线 47 节点",
  author: "编辑部 · 深挖组",
  img: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20documentary%20still%2C%20night%20city%20alleyway%20with%20a%20brightly%20lit%20takeout%20storefront%20sign%20glowing%20warm%20amber%2C%20a%20blurred%20investigative%20reporter%20silhouette%20holding%20a%20notebook%20at%20the%20corner%2C%20moody%20chiaroscuro%20lighting%20with%20crimson%20and%20amber%20rim%20light%2C%20heavy%20film%20grain%2C%20high%20contrast%2C%20shallow%20depth%20of%20field%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=1280&height=720&seq=hm-hero-2026-01&orientation=landscape",
};

export interface SpeedNews {
  id: number;
  time: string;
  title: string;
  views: string;
}

export const speedNews: SpeedNews[] = [
  { id: 1, time: "14:10", title: "直播话术单再流出一份，『全款返现』真实规则与话术对不上", views: "28.6w" },
  { id: 2, time: "13:26", title: "低价旅游团购物点抽成明细曝光，返佣比例按项目分档", views: "21.9w" },
  { id: 3, time: "12:44", title: "充电宝涨价背后的代理分成结构，被逐层拆开比价", views: "19.3w" },
  { id: 4, time: "11:58", title: "明星同款白牌倒钩事件复盘：价格一路下探的三段真相", views: "33.1w" },
  { id: 5, time: "11:02", title: "婚庆 '套餐加价' 话术盘点，合同里被漏读的三处细节", views: "15.7w" },
];

export interface HotItem {
  id: number;
  title: string;
  tag: string;
  heat: number;
  delta: number;
}

export const hotRank: HotItem[] = [
  { id: 1, title: "某头部 MCN 直播带货脚本库全文流出", tag: "直播", heat: 96, delta: 3 },
  { id: 2, title: "加盟招商会录音档：快招话术逐句解析", tag: "招商", heat: 91, delta: 1 },
  { id: 3, title: "充电宝涨价背后的代理分成与定价链路", tag: "消费", heat: 87, delta: 5 },
  { id: 4, title: "低价旅游团购物点抽成比例明细复盘", tag: "行业", heat: 82, delta: 2 },
  { id: 5, title: "求职 App 付费内推争议：资源匹配度追踪", tag: "职场", heat: 76, delta: 0 },
  { id: 6, title: "婚庆套餐加价话术与合同细节三重拆解", tag: "消费", heat: 71, delta: -1 },
  { id: 7, title: "培训机构 '保过' 承诺背后的退费条款", tag: "教育", heat: 64, delta: 2 },
  { id: 8, title: "新消费品牌价格跳水始末的多方说法", tag: "品牌", heat: 58, delta: -3 },
];

export const radarTags: string[] = [
  "直播带货话术", "加盟招商", "低价旅游团", "充电宝涨价", "明星联名白牌",
  "付费内推", "婚庆套餐", "机构保过", "团购佣金", "会员卡暗扣", "外卖满减套路", "保健品会销",
];

export interface Topic {
  name: string;
  desc: string;
  count: string;
  img: string;
}

export const topicList: Topic[] = [
  {
    name: "塌房复盘",
    desc: "爆红—失控—回应—清算，还原每个翻车现场是怎么一步步走偏的。",
    count: "126 篇档案",
    img: "https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20a%20smashed%20glowing%20neon%20storefront%20sign%20with%20cracked%20glass%2C%20warm%20amber%20and%20crimson%20lighting%2C%20heavy%20film%20grain%2C%20dramatic%20chiaroscuro%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=640&seq=hm-topic-crash-01&orientation=squarish",
  },
  {
    name: "消费套路",
    desc: "充值、满减、抽成、附加费……把藏在订单和话术里的小动作摊开看。",
    count: "98 篇档案",
    img: "https://readdy.ai/api/search-image?query=overhead%20editorial%20photograph%20of%20a%20cluttered%20desk%20covered%20in%20receipts%2C%20price%20tags%20and%20a%20magnifying%20glass%2C%20warm%20desk%20lamp%20light%20and%20crimson%20shadows%2C%20heavy%20film%20grain%2C%20high%20contrast%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=640&seq=hm-topic-consume-01&orientation=squarish",
  },
  {
    name: "职场黑话",
    desc: "把求职、内推、培训与晋升话术里的潜台词，一句句翻译成人话。",
    count: "73 篇档案",
    img: "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20an%20empty%20open%20plan%20office%20at%20night%2C%20desks%20lit%20only%20by%20computer%20screens%20and%20warm%20desk%20lamps%2C%20crimson%20and%20amber%20highlights%2C%20heavy%20film%20grain%2C%20moody%20chiaroscuro%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=640&seq=hm-topic-job-01&orientation=squarish",
  },
  {
    name: "行业潜规则",
    desc: "低价游、团购佣金、代理分成……横切一条产业链看利润怎么流动。",
    count: "85 篇档案",
    img: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20tour%20bus%20parked%20in%20a%20dull%20parking%20lot%20at%20dusk%2C%20rows%20of%20tourists%20waiting%20in%20silhouette%2C%20warm%20amber%20street%20light%20and%20cool%20shadows%2C%20heavy%20film%20grain%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=640&seq=hm-topic-industry-01&orientation=squarish",
  },
  {
    name: "争议现场",
    desc: "公说公有理的罗生门，把当事多方说法与证据一起摆上桌。",
    count: "61 篇档案",
    img: "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20two%20empty%20chairs%20facing%20each%20other%20across%20a%20table%20under%20a%20single%20harsh%20hanging%20lamp%2C%20microwave%20halo%20and%20deep%20shadows%2C%20warm%20amber%20light%20with%20crimson%20accents%2C%20heavy%20film%20grain%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=640&seq=hm-topic-debate-01&orientation=squarish",
  },
  {
    name: "幕后始末",
    desc: "一件麻烦事的前因后果，从线索冒出到尘埃落定的完整编年。",
    count: "54 篇档案",
    img: "https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20a%20desk%20with%20an%20old%20typewriter%2C%20scattered%20printed%20timeline%20documents%20and%20paper%20clips%2C%20single%20warm%20desk%20lamp%20beam%2C%20crimson%20rim%20light%20from%20the%20side%2C%20heavy%20film%20grain%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=640&seq=hm-topic-behind-01&orientation=squarish",
  },
];

export interface FeedItem {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  meta: string;
  read: string;
  time: string;
  tone: TagTone;
  img: string;
  big?: boolean;
}

export const mixedFeed: FeedItem[] = [
  {
    id: 1,
    category: "招商",
    title: "招商会现场的『前 50 名享补贴』，为什么永远轮不到普通人",
    excerpt: "我们混进三场快招说明会，把座位安排、托儿分工与限时逼单的节奏逐段复盘，看一张合同背后如何同时完成「造势—施压—成单」三步。",
    meta: "音频实录 · 12 段",
    read: "18 分钟",
    time: "今日",
    tone: "accent",
    img: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20conference%20room%20with%20rows%20of%20empty%20chairs%20facing%20a%20brightly%20lit%20stage%2C%20projector%20screen%20glowing%2C%20warm%20amber%20and%20crimson%20lighting%2C%20heavy%20film%20grain%2C%20dramatic%20chiaroscuro%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=900&height=600&seq=hm-feed-a01&orientation=landscape",
    big: true,
  },
  {
    id: 2,
    category: "消费",
    title: "同一款会员卡，为什么新客比老客便宜一半",
    excerpt: "把定价字段翻来覆去比对，背后是「杀熟」还是单纯的价格分层，用一组真实下单记录说话。",
    meta: "图文对照",
    read: "9 分钟",
    time: "今日",
    tone: "secondary",
    img: "https://readdy.ai/api/search-image?query=editorial%20macro%20photograph%20of%20two%20similar%20credit%20cards%20and%20a%20smartphone%20showing%20a%20price%20comparison%20on%20a%20wooden%20desk%2C%20warm%20desk%20lamp%20light%20with%20crimson%20shadows%2C%20heavy%20film%20grain%2C%20high%20contrast%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=480&seq=hm-feed-b01&orientation=landscape",
  },
  {
    id: 3,
    category: "职场",
    title: "『付费内推』到底推了个什么：我们追踪了 200 份简历",
    excerpt: "资源真假、岗位虚实与中间商差价，用受访者口述拼出一张完整的生意链。",
    meta: "调查随访",
    read: "12 分钟",
    time: "昨日",
    tone: "secondary",
    img: "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20stack%20of%20resumes%20on%20a%20desk%20beside%20a%20laptop%20screen%20glowing%20with%20a%20recruitment%20page%2C%20warm%20amber%20lamp%20and%20crimson%20highlights%2C%20heavy%20film%20grain%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=480&seq=hm-feed-c01&orientation=landscape",
  },
  {
    id: 4,
    category: "直播",
    title: "直播间里那句『最后三单』，被我们录下了 40 次",
    excerpt: "同一场次库存话术与实际上架数量的逐句对照，看限时稀缺如何被精密排练。",
    meta: "音画对照",
    read: "11 分钟",
    time: "昨日",
    tone: "accent",
    img: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20live%20streaming%20studio%20at%20night%20with%20a%20glowing%20phone%20ring%20light%20and%20product%20shelf%20in%20the%20backdrop%2C%20empty%20interview%20chair%20in%20front%2C%20warm%20amber%20and%20crimson%20lighting%2C%20heavy%20film%20grain%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=480&seq=hm-feed-d01&orientation=landscape",
  },
  {
    id: 5,
    category: "行业",
    title: "团购佣金明涨暗降：商家后台里的两套账",
    excerpt: "同一份订单在不同时间点的分成差异，我们把后台截图逐项标记还原。",
    meta: "证据比对",
    read: "8 分钟",
    time: "2 天前",
    tone: "secondary",
    img: "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20small%20restaurant%20counter%20with%20a%20merchant%20dashboard%20open%20on%20a%20tablet%20beside%20a%20till%20and%20receipts%2C%20warm%20bulb%20light%20and%20crimson%20shadows%2C%20heavy%20film%20grain%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=480&seq=hm-feed-e01&orientation=landscape",
  },
  {
    id: 6,
    category: "消费",
    title: "充电宝半小时 6 元：这笔账的利润最后进了谁的口袋",
    excerpt: "从分时计价到代理分成，沿着一次扫码把整条结算链上的每一环标出来。",
    meta: "链路图解",
    read: "7 分钟",
    time: "2 天前",
    tone: "secondary",
    img: "https://readdy.ai/api/search-image?query=editorial%20closeup%20photograph%20of%20a%20shared%20power%20bank%20charging%20station%20in%20a%20dim%20store%2C%20screen%20glowing%20with%20price%2C%20phone%20being%20charged%2C%20warm%20amber%20light%20and%20crimson%20highlights%2C%20heavy%20film%20grain%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=480&seq=hm-feed-f01&orientation=landscape",
  },
  {
    id: 7,
    category: "教育",
    title: "『保过班』的过，是哪种过：退费条款里的文字迷宫",
    excerpt: "把三版合同并排比对，找出同一承诺在赔付条件上的反复腾挪。",
    meta: "合同比对",
    read: "10 分钟",
    time: "3 天前",
    tone: "secondary",
    img: "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20classroom%20desk%20with%20exam%20papers%20and%20a%20signed%20contract%20under%20a%20fluorescent%20and%20warm%20mixed%20light%2C%20crimson%20accent%2C%20heavy%20film%20grain%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=900&height=600&seq=hm-feed-g01&orientation=landscape",
    big: true,
  },
  {
    id: 8,
    category: "品牌",
    title: "联名白牌的三级跳：首发、饥饿与清仓的定价剧本",
    excerpt: "把一款联名商品从发布到打折的全过程整理成可核对的降价节点表。",
    meta: "价格追踪",
    read: "6 分钟",
    time: "3 天前",
    tone: "primary",
    img: "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20single%20celebrity%20collaboration%20sneaker%20box%20on%20a%20wooden%20table%20with%20price%20tags%20dangling%2C%20warm%20amber%20spotlight%20and%20crimson%20shadows%2C%20heavy%20film%20grain%2C%20high%20contrast%2C%20documentary%20newsroom%20aesthetic%2C%20no%20text&width=640&height=480&seq=hm-feed-h01&orientation=landscape",
  },
];

export interface TimelineStep {
  phase: string;
  date: string;
  title: string;
  desc: string;
  evidence: string;
  state: "done" | "active" | "open";
}

export const timelineSteps: TimelineStep[] = [
  {
    phase: "起因",
    date: "第 1 周",
    title: "一支排队短视频走红",
    desc: "某茶饮首店开业当晚，门口排队长龙冲上同城热搜，加盟咨询量一夜翻倍。",
    evidence: "视频定位 · 到店客流截图",
    state: "done",
  },
  {
    phase: "发酵",
    date: "第 2 周",
    title: "招商说明会集中铺开",
    desc: "快招团队在多个城市连开说明会，以「区域保护 + 限时名额」话术推动现场签约。",
    evidence: "说明会录音 · 签约合同",
    state: "done",
  },
  {
    phase: "转折",
    date: "第 3 周",
    title: "门店闭店信号浮现",
    desc: "首批加盟店月营业额未达口头承诺，陆续出现转让与闭店，会员储值退款被拖延。",
    evidence: "门店实拍 · 售后记录",
    state: "active",
  },
  {
    phase: "回应",
    date: "第 4 周",
    title: "官方声明与加盟商说法各执一词",
    desc: "品牌方回应「个别门店经营不善」，加盟商则出示总部承诺书提出分歧，罗生门形成。",
    evidence: "声明原文 · 双方往来",
    state: "open",
  },
  {
    phase: "后续",
    date: "追踪中",
    title: "清算与责任梳理仍在推进",
    desc: "我们正按合同条款与收款主体逐项对账，最新进展将以增补章节持续更新。",
    evidence: "对账进度 · 待核实",
    state: "open",
  },
];

export interface CommentItem {
  id: number;
  name: string;
  tag: string;
  text: string;
  likes: string;
  time: string;
}

export const hotComments: CommentItem[] = [
  {
    id: 1,
    name: "按时下班",
    tag: "追更用户",
    text: "时间线排得够细，终于搞懂加盟和直营的钱根本不是一个池子。看完再下单心里有数。",
    likes: "1.2w",
    time: "2 小时前",
  },
  {
    id: 2,
    name: "第二杯半价",
    tag: "新关注",
    text: "那一段录音跟现场说法对不上，蹲后续，别删。",
    likes: "9861",
    time: "3 小时前",
  },
  {
    id: 3,
    name: "理性吃瓜",
    tag: "追更用户",
    text: "把两边证据都摆出来再下结论，这种写法比单方面输出舒服多了。",
    likes: "7634",
    time: "5 小时前",
  },
  {
    id: 4,
    name: "路过的风",
    tag: "新关注",
    text: "开头那张排队视频原来可能是演的？重新看了一遍发现破绽。",
    likes: "5410",
    time: "6 小时前",
  },
];

export const editorPicks: string[] = [
  "我们为什么不用『实锤』这个词，只用『证据指向』",
  "一条完整时间线是怎么被拼出来的：方法论公开",
  "把录音转成文字前，我们做了这三道核实",
  "收到匿名爆料后，编辑部的第一反应不是发稿",
];

export const footColumns = [
  {
    title: "栏目",
    links: ["今日封面", "热度榜", "专题合集", "始末时间线", "深度长文", "观点交锋"],
  },
  {
    title: "指南",
    links: ["投稿与爆料", "证据核实流程", "更正与致歉", "创作规范"],
  },
  {
    title: "关于",
    links: ["关于最全黑料", "编辑团队", "联系我们", "商务合作"],
  },
];

export const mottoList: string[] = [
  "把一件事的前因后果讲透",
  "证据先行，标题不越界",
  "多方说法，一样不删",
  "结论慢一点，材料齐一点",
];